import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./components/Home";
import { Col, Container, Nav, Navbar, NavDropdown, Row, Spinner } from "react-bootstrap";


import EstructuraOperativa from "./components/incidentes/EstructuraInterna/EstructuraOperativa";
import OrganigramaOperacional from "./components/incidentes/EstructuraInterna/OrganigramaOperacional";


import ProcesoCompleto from "./components/incidentes/ProcesoComercialIT/ProcesoCompleto";
import DocumentoProcesoComercialIT from "./components/incidentes/ProcesoComercialIT/DocumentoProcesoComercialIT";
import CreacionDocumentacion from "./components/incidentes/ProcesoComercialIT/docgen/CreacionDocumentacion";
import TableroProyectos from "./components/incidentes/ProcesoComercialIT/docgen/TableroProyectos";


import DocumentosInstitucionales from "./components/incidentes/Operaciones/DocumentosInstitucionales";
import MesaAyudaCliente from "./components/incidentes/Operaciones/MesaAyudaCliente";
import ImagenCorporativa from "./components/incidentes/Operaciones/ImagenCorporativa";
import DescripcionesPuestos from "./components/incidentes/Operaciones/DescripcionesPuestos";
import PuestoPM from "./components/incidentes/Operaciones/PuestoPM";


import ProcesoComercialIngenieria from "./components/incidentes/Ingeniera/ProcesoComercialIngenieria";
import DocumentoProcesoComercial from "./components/incidentes/Ingeniera/DocumentoProcesoComercial";


import GestionServiciosContratados from "./components/incidentes/Ingeniera/GestionServiciosContratados";
import Poliza from "./components/incidentes/Ingeniera/Poliza";


import ProcesosInternos from "./components/incidentes/Ingeniera/ProcesosInternos";
import DocumentoProcesoInterno from "./components/incidentes/Ingeniera/DocumentoProcesoInterno";
import GuiasTrabajoOnSite from "./components/incidentes/Ingeniera/GuiasTrabajoOnSite";


import RecursosHumanos from "./components/incidentes/AdministracionFinanzas/RecursosHumanos";
import ProcedimientoRH from "./components/incidentes/AdministracionFinanzas/ProcedimientoRH";


import { SUBMENUS_FORMACION, MODULOS_FORMACION } from "./components/incidentes/Capacitaciones/formacionMenu";
import Python from "./components/incidentes/Capacitaciones/python";
import PythonTema from "./components/incidentes/Capacitaciones/PythonTema";


import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Login from "./components/Login";
import Navigation from "./components/Navigation";


function App() {
  const { instance, accounts } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await instance.initialize();
        setIsInitialized(true);
      } catch (e) {
        console.error(e);
      }
    };

    initializeMsal();
  }, [instance]);

  const handleLogin = async () => {
    await instance.loginPopup(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  const handleLogout = async () => {
    try {
      await instance.logoutPopup();
    } catch (e) {
      console.error(e);
    }
  };

  const [setGraphData] = useState(null);

  useEffect(() => {
    if (isInitialized && accounts.length > 0) {
      const account = accounts[0];
  
      const fetchData = async () => {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account,
          });
          const graphResponse = await fetch(
            "https://graph.microsoft.com/v1.0/me",
            {
              headers: {
                Authorization: `Bearer ${response.accessToken}`,
              },
            }
          );
  
          const data = await graphResponse.json();
          setGraphData(data);
        } catch (e) {
          console.error("Error acquiring token or fetching data:", e);
        }
      };
  
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, accounts, instance]);

  if (!isInitialized) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="sr-only"></span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      {accounts.length > 0 ? (
        <>
          <Router>
            <Container fluid className="background">
              <Row className="justify-content-center">
                <Navbar bg="light" expand="md" fixed="top">
                  <Navbar.Brand href="/inicio" className="mr-5" style={{ marginLeft: '200px' }}>
                    Intranet Netjer Networks
                  </Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav" style={{ justifyContent: 'center' }}>
                    <Nav className="ml-auto">
                      
                      
                      <NavDropdown 
                        title="Estructura Interna"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item 
                            as={Link} 
                            to="/organigrama-operacional"
                        >
                          Organigrama Operacional
                        </NavDropdown.Item>

                      
                      </NavDropdown>
                      <NavDropdown 
                        title="Proceso Comercial"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to="/proceso-completo-it"
                        >
                          Proceso Comercial IT
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/creacion-documentacion"
                        >
                          Creación de Documentación
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/tablero-proyectos"
                        >
                          Tablero de Proyectos
                        </NavDropdown.Item>
                      </NavDropdown>
                      
                      
                      <NavDropdown 
                        title="Operaciones"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item 
                          as={Link}
                          to="/documentos-institucionales">
                          Documentos Institucionales
                        </NavDropdown.Item>
                        <NavDropdown.Item 
                          as={Link}
                          to="/imagen-corporativa">
                          Imagen Corporativa
                        </NavDropdown.Item>
                        <NavDropdown.Item 
                          as={Link}
                          to="/descripciones-puestos">
                          Descripciones de Puestos
                        </NavDropdown.Item>
                      </NavDropdown>
                      

                      <NavDropdown
                        title="Ingeniería"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to="/proceso-comercial-ingenieria"
                        >
                          Proceso Comercial IT-Ingenería
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/procesos-internos"
                        >
                          Procesos Internos
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/guias-trabajo-on-site"
                        >
                          Guías Trabajo On Site
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/gestion-servicios-contratados"
                        >
                          Gestión de Servicios Contratados
                        </NavDropdown.Item>
                      </NavDropdown>
                      

                      <NavDropdown
                        title="Administración y Finanzas"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to="recursos-humanos"
                        >
                          Recursos Humanos
                        </NavDropdown.Item>
                      </NavDropdown>
                      
                      
                      <NavDropdown title="Formación" id="basic-nav-dropdown">

                        {SUBMENUS_FORMACION.map((submenu) => (
                          <React.Fragment key={submenu.id}>
                            <NavDropdown.Header>{submenu.titulo}</NavDropdown.Header>
                            {submenu.modulos.map((modulo) => (
                              <NavDropdown.Item as={Link} to={modulo.path} key={modulo.path}>
                                {modulo.label}
                              </NavDropdown.Item>
                            ))}
                            <NavDropdown.Divider />
                          </React.Fragment>
                        ))}

                        <NavDropdown.Header>Python</NavDropdown.Header>
                        <NavDropdown.Item as={Link} to="python">
                          Python
                        </NavDropdown.Item>

                      </NavDropdown>


                      <Nav.Link
                        as="a"
                        href="https://netjernetworks.atlassian.net/servicedesk/customer/portals"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#000000',
                          fontSize: '16px',
                          fontWeight: 600,
                          textDecoration: 'none',
                          background: 'none',
                          border: 'none',
                        }}                      
                      >
                        Tickets
                      </Nav.Link>


                      <Nav.Item>
                        <Nav.Link className="btn-logout" onClick={handleLogout}>Cerrar sesión</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </Row>
              <Row className="bg-light" id="submenu">
                <Col md={{ offset: 1, span: 10 }}>
                  <p className="navigation">Bienvenido, {accounts[0].name}</p>
                </Col>
                <Col md={{ offset: 1, span: 11 }} className="nav-sections">
                  <Navigation />
                </Col>
              </Row>
            </Container>
            <Container fluid className="main">
              <Routes>
                <Route path="/inicio" element={<Home />} />
                <Route path="/" element={<Home />} />

                <Route
                  path="/organigrama-operacional"
                  element={<OrganigramaOperacional />}
                />
                <Route
                  path="/organigrama-operacional/estructura-operativa"
                  element={<EstructuraOperativa />}
                />


                <Route
                  path="/proceso-completo-it"
                  element={<ProcesoCompleto />}
                />
                <Route
                  path="/proceso-completo-it/:slug"
                  element={<DocumentoProcesoComercialIT />}
                />
                <Route
                  path="/creacion-documentacion"
                  element={<CreacionDocumentacion />}
                />
                <Route
                  path="/tablero-proyectos"
                  element={<TableroProyectos />}
                />
                


                <Route
                  path="/documentos-institucionales"
                  element={<DocumentosInstitucionales />}
                />
                <Route
                  path="/documentos-institucionales/mesa-ayuda-cliente"
                  element={<MesaAyudaCliente />}
                />
                <Route
                  path="/imagen-corporativa"
                  element={<ImagenCorporativa />}
                />
                <Route
                  path="/descripciones-puestos"
                  element={<DescripcionesPuestos />}
                />
                <Route
                  path="/descripciones-puestos/puesto-pm"
                  element={<PuestoPM />}
                />


                <Route
                  path="/proceso-comercial-ingenieria"
                  element={<ProcesoComercialIngenieria />}
                />
                <Route
                  path="/proceso-comercial-ingenieria/:slug"
                  element={<DocumentoProcesoComercial />}
                />


                <Route
                  path="/procesos-internos"
                  element={<ProcesosInternos />}
                />
                <Route
                  path="/procesos-internos/:slug"
                  element={<DocumentoProcesoInterno />}
                />


                <Route
                  path="/guias-trabajo-on-site"
                  element={<GuiasTrabajoOnSite />}
                />


                <Route
                  path="/gestion-servicios-contratados"
                  element={<GestionServiciosContratados />}
                />
                <Route
                  path="/gestion-servicios-contratados/:slug"
                  element={<Poliza />}
                />


                <Route
                  path="/recursos-humanos"
                  element={<RecursosHumanos />}
                />
                <Route
                  path="/recursos-humanos/:slug"
                  element={<ProcedimientoRH />}
                />



                {MODULOS_FORMACION.map(({ path, Component }) => (
                  <Route key={path} path={`/${path}`} element={<Component />} />
                ))}

                <Route
                  path="/python"
                  element={<Python />}
                />
                <Route
                  path="/python/tema-:numero"
                  element={<PythonTema />}
                />

              </Routes>
            </Container>
          </Router>
        </>
      ) : (
        <Login handleLogin={handleLogin} />
      )}
    </>
  );
}
export default App;